import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

export const DashboardMainContainer = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  padding: theme.spacing(2),
  borderRadius: theme.shape.borderRadius, // From theme.shape.borderRadius (default 4px)
  boxShadow: theme.shadows[2],
  marginBottom: theme.spacing(3),
}));

export const DashboardHeaderBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: theme.spacing(2),
  paddingBottom: theme.spacing(1.5),
  borderBottom: `1px solid ${theme.palette.divider}`,
  borderColor: theme.palette.divider,
}));

// Reusable styled Box for individual metric items
export const MetricItemBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: theme.spacing(2), // Uses theme's spacing unit (8px by default)
  backgroundColor: theme.palette.background.paper,
  border: `1px solid ${theme.palette.divider}`, // Uses theme's divider color
  borderRadius: theme.shape.borderRadius, // Uses theme's default border-radius (4px)
  boxShadow: theme.shadows[1], // Uses theme's shadow scale
}));

// Reusable styled Paper for the overall metrics summary card
export const MetricSummaryPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(2),
  marginBottom: theme.spacing(3),
  textAlign: 'center',
  backgroundColor: theme.palette.background.paper,
  border: `1px solid ${theme.palette.divider}`,
  boxShadow: theme.shadows[2],
}));

// Reusable styled Typography for metric counts
export const MetricCountTypography = styled(Typography)(({ theme }) => ({
  fontSize: '2.2em',
  fontWeight: 'bold',
  color: theme.palette.primary.main,
  marginBottom: theme.spacing(0.5),
}));

// add more styled components here, e.g., for common form fields, etc.